import styled from 'styled-components';

import { purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

export const ToggleMapButtonContainer = styled.div`
    ${purpurMedia('xl')`
        display: none;
    `};
`;
